import React, { Fragment } from 'react';
import bookingdetails1 from '../../../../images/details1.png';
import bookingdetails2 from '../../../../images/details2.png';

const BookingDetails = () => (
  <Fragment>
    <p>You will see your upcoming booking details on the Dashboard.</p>
    <br />
    <div style={{ textAlign: 'center' }}>
      <img
        src={bookingdetails1}
        style={{ width: '200px', height: '455px' }}
      />
      <img
        src={bookingdetails2}
        style={{ width: '200px', height: '455px' }}
      />
    </div>
    <br />
    <p>
      When your booking begins, open your Autzu app and select “I’m at the
      hub”. An Autzu vehicle will then be assigned to your booking. You
      will be provided the vehicle information such as its license plate
      number and parking spot number.
    </p>
  </Fragment>
);

export default BookingDetails;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/MakingABooking/BookingDetails.js